import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export const selectCommands = (state) => get(state, 'fileUploaderContext.commandsInProcess', []);
export const selectUnfinishedCommands = (state) => selectCommands(state).filter((c) => !c.finished);
export const selectIsProcessingFiles = (state) => !isEmpty(selectCommands(state).filter((c) => c.fileType === 'file'));
